import { FaWhatsapp } from 'react-icons/fa';

import { SubHeading } from '../../components';

import { images } from '../../constants';
import './FooterOverlay.css';

const FooterOverlay = () => (
    <div className="app__footerOverlay">
      <div className="app__footerOverlay-contents section__padding flex__center">
        <div className='app__footerOverlay-aboutUs'>
          <SubHeading title='About Us' />
          
          <p className='p__opensans'>At The Fortress experience a culinary sanctuary where the flavors of Portuguese, Italian, Greek, and African cuisines come together. Our name reflects opulence and excellence, catering to those who savor life's exquisite pleasures.</p>
        </div>

        <div className="app__footerOverlay-img">
          <img src={images.mainLogo} alt="logo" />
          <p className="p__opensans" id='copyright'>&copy; {new Date().getFullYear()} Fortress Restaurant. All rights reserved.</p>
        </div>

        <div className='app__footerOverlay-contactUs'>
          <SubHeading title='Contact Us' />

          <p className='p__opensans'>Ext 2, Menlyn Maine, Central Square, Shop No. 103</p>
          <p className='p__opensans'>Waterkloof Glen, Bancor Avenue</p>
          <p className='p__opensans'>Pretoria East, South Africa, 0181</p>
          <p className='p__opensans'>Phone: <a href="tel:0127860145" className="p__opensans phone-link">
          012&nbsp;786&nbsp;0145
        </a></p>
          <div className="app__footerOverlay-contactUs_whatsapp flex__center">
            <FaWhatsapp size={20} color= 'green' />
            <a className='p__opensans' href='https://wa.me/+27694336650' target='_blank' rel='noreferrer'>WhatsApp Us</a>
          </div>
        </div>
      </div>
    </div>
  );
export default FooterOverlay;
